export const ABOUT_TEAM_MEMBERS = [
  { id: '0', photo: '/images/landing/team/member-0.jpg' },
  { id: '1', photo: '/images/landing/team/member-1.jpg' },
  { id: '2', photo: '/images/landing/team/member-2.jpg' },
] as const;
